import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Services from './pages/Services';
import LanguageClasses from './pages/LanguageClasses';
import Gallery from './pages/Gallery';
import Universities from './pages/Universities';
import Contact from './pages/Contact';
import About from './pages/About';
import ExplorePrograms from 'pages/ExplorePrograms';
import FounderMessage from './pages/FounderMessage';
import ApplyNow from './pages/ApplyNow';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import NotFound from './pages/NotFound';
import { ToastProvider } from './contexts/ToastContext';

import { pageview, initGA } from './utils/analytics';

// Analytics tracker component
const RouteTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Initialize GA if needed
    initGA();
    
    // Track page view when location changes
    pageview(location.pathname + location.search);
  }, [location]);
  
  return null;
};

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <ToastProvider>
        <Router>
          <ScrollToTop />
          <RouteTracker />
          <div className="min-h-screen flex flex-col">
            <Navbar />
            <main className="flex-grow">
              <Routes>
                {/* Main Routes */}
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/founder-message" element={<FounderMessage />} />
                <Route path="/services" element={<Services />} />
                <Route path="/language-classes" element={<LanguageClasses />} />
                <Route path="/universities" element={<Universities />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/contact" element={<Contact />} />
                {/* <Route path="/explore-programs" element={<ExplorePrograms />} /> */}
                <Route path="/apply" element={<ApplyNow />} />
                
                {/* Legal Pages */}
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                
                {/* Services Routes */}
                <Route path="/services/study-in-japan" element={<Services />} />
                <Route path="/services/university-applications" element={<Services />} />
                <Route path="/services/language-schools" element={<Services />} />
                <Route path="/services/scholarships" element={<Services />} />
                <Route path="/services/student-visa" element={<Services />} />
                <Route path="/services/work-visa" element={<Services />} />
                <Route path="/services/dependent-visa" element={<Services />} />
                <Route path="/services/job-placement" element={<Services />} />
                <Route path="/services/resume-building" element={<Services />} />
                <Route path="/services/interview-preparation" element={<Services />} />

                {/* Language Class Routes */}
                <Route path="/language-classes/beginner" element={<LanguageClasses />} />
                <Route path="/language-classes/intermediate" element={<LanguageClasses />} />
                <Route path="/language-classes/advanced" element={<LanguageClasses />} />
                <Route path="/language-classes/business" element={<LanguageClasses />} />
                <Route path="/language-classes/conversational" element={<LanguageClasses />} />
                <Route path="/language-classes/kanji" element={<LanguageClasses />} />
                <Route path="/language-classes/textbooks" element={<LanguageClasses />} />
                <Route path="/language-classes/practice-tests" element={<LanguageClasses />} />
                <Route path="/language-classes/online-resources" element={<LanguageClasses />} />
                
                {/* 404 - Not Found - This must be the last route */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </ToastProvider>
    </HelmetProvider>
  );
};

export default App;
